export default "__VITE_ASSET__f283bb89__"